import PropTypes from 'prop-types';
import React from 'react';

const LazyImg = ({
  src,
  alt,
  className,
  ...props
}) => (
  <img
    className={`lozad lozad-load ${className}`}
    data-toggle-class="lozad-loaded"
    alt={alt || 'img'}
    data-src={src}
    {...props}
  />
);

LazyImg.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  className: PropTypes.string,
};

export default LazyImg;
